import FieldUser, {ADD_USER} from "../../../../generic/user/user";
import FieldConfig from "../../../../proto/field-config";
import {ProjectAccess} from "../../../../../gd/const/project";
import FieldTaskAssignedToUser_ConditionForm from "./render/condition";
import FieldTaskAssignedToUser_QuickFilterView from "./render/quick-filter-view";
import Task from "../../../../../model2/task/task";
import FieldTaskAssignedToUser_GoalListEditable from "./render/goal-list-editable"
import FieldTaskAssignedToUser_PickerValueNotEmpty from "./components/picker/value-not-empty"
import FieldTaskAssignedToUser_GoalListView from "./render/goal-list-view";
import ItemModel from "../../../../../model2/item/item-model";
import TableManager from "../../../../../gd-modules/table/manager/table-manager";
import TaskListManager from "../../../../../gd-modules/task-list/manager/manager";
import {LifecycleAction} from "../../../../../gd/const/lifecycle";
import {FieldType} from "../../../../field-type";

export default class FieldTaskAssignedToUser extends FieldUser {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel = "Task Assigned to User";

        // this.noValueOption = true;
        // this.noValueOptionLabel = 'Not assigned';

        // this.components = _.assign({}, this.components, {
        //     PopoverMenuMore : null,
        // })

        this.placeholder                            = "Not assigned"

        this.components.PopoverMenuMore             = null
        this.components.PickerValueNotEmpty     = FieldTaskAssignedToUser_PickerValueNotEmpty

        this.classes.PopoverMenuScrollContainer    = 'min-w-250 max-h-300'

        this.renderComponents.conditionForm = FieldTaskAssignedToUser_ConditionForm
        this.renderComponents.quickFilterView = FieldTaskAssignedToUser_QuickFilterView
        this.renderComponents.goalListEditable  = FieldTaskAssignedToUser_GoalListEditable
        this.renderComponents.goalListView      = FieldTaskAssignedToUser_GoalListView


        this.fieldParams.tableCellOnValueChange     = this.tableCellOnValueChange

    }

    canEdit(model: Task): boolean {
        return model.acl.canChangeAssignedTo
    }

    access(model:any) {
        return gd.const.systemStatus.isOpen(model.systemStatus) && gd.ac.check.project.fullAccess(model.projectId) ? 'write' : 'read';
    }

    getOptionsForEdit(model:any) {

        const options:Option[] = []

        // model = Task
        const projectId     = model.projectId
        // const taskTypeId    = model.taskTypeId

        if (!projectId) {
            console.log("FieldTaskActionRequired #ERROR-FIELD-TASK-ACTION-REQUIRED-USER-45 no model passed")
            return []
        }

        const projectUsers = gd.session.projectUsers.filterByProject(projectId, gd.const.project.access.LIMITED)

        // now we need to remove clients and read only users from this list
        projectUsers.map((projectUser:any)=>{
            // make sure company user exists
            const companyUser = gd.session.companyUsers.getByUserId(projectUser.user.id)
            if (!companyUser) return

            // make sure it's not client
            if (companyUser.companyRole === gd.const.companyRole.CLIENT) return

            // make sure they have edit access
            if ([ProjectAccess.READ_ONLY, ProjectAccess.CLIENT].includes(projectUser.access)) return

            options.push({
                value: projectUser.user.id,
                label: projectUser.user.name
            })
        })

        // there can be no acl in model (for example RequestForm model)
        if (model.acl?.canAddProjectUser) {
            options.push({
                value   : ADD_USER,
                label   : 'Add User',
                icon    : 'i5-plus'
            })
        }

        return options

    }

    tableCellOnValueChange = (item:ItemModel, value:any, manager:TableManager|TaskListManager) => {


        // Special case whn add a user
        if (value === ADD_USER) {
            item.task.addUserAsAssignee()
            return
        }


        item.task.assignedToUserId = value
        item.task.save()

        item._updateLastUpdateTime() // otherwise it wont re-render

        // need it becuase of workday duration depends on Assignee
        manager.update([LifecycleAction.PROCESS_DATA, LifecycleAction.RENDER])

    }



}
